// src/components/Footer.jsx

import React from 'react';
import '../styles/footerStyle.css';
import { PHARMACY_NUMBER } from '../constants/constant';
import { formatPhoneNumber } from '../utils/phoneFormatter';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* About Section */}
        <div className="footer-about">
          <img src="/assets/logo.jpg" alt="Mirror Lake Pharmacy Logo" className="footer-logo" />
          <p>
            Locally owned and operated pharmacy where you get The "right service at right time".
            RPh Cameron DeLong has been working in the city of Camrose for more than 9 years and
            has vast experience in geriatric care and prescribing for patients' health needs.
          </p>
          {/* <button className="policy-btn">Policy for Accessibility Standards</button> */}
        </div>

        {/* Location Info */}
        <div className="footer-location">
          <h3>MIRROR LAKE PHARMACY</h3>
          <p>Unit# 103, 5403 48 Ave, Camrose, AB - T4V 0J6</p>
          {/* <p><i className="fa fa-phone"></i> <a className="telephone" href="tel:+15872007123">+1 587-200-7123</a> <span> | </span> */}
          <p><i className="fa fa-phone"></i> <a className="telephone" href={`tel:${PHARMACY_NUMBER}`}>{formatPhoneNumber(PHARMACY_NUMBER)}</a> <span> | </span>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=5403+48+Ave+Unit+103,+Camrose,+AB+T4V+0J6"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <i className="fa fa-location-dot"></i> Map
            </a>
            <span> | </span> <a className="telephone" href="mailto:mirrorlakepharmacy@gmail.com">mirrorlakepharmacy@gmail.com</a>
          </p>

          <div className="store-hours">
            <strong>Store Hours:</strong>
            <p>Mon - Fri: 9:00 AM - 6:00 PM</p>
            <p>Sat - Sun: 9:00 AM - 6:00 PM</p>
          </div>

          <a
            href="https://www.facebook.com/people/Mirror-Lake-Pharmacy-Care-Clinic/61573404875989/"
            target="_blank"
            rel="noopener noreferrer"
            className="facebook-btn facebook-btn-text"
          >
            <i className="fa-brands fa-square-facebook"></i> Like and visit our Facebook page
          </a>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© 2025 Mirror Lake Pharmacy. All rights reserved. Website built with love.</p>
      </div>
    </footer>
  );
}

export default Footer;